module.exports = __webpack_public_path__ + "img/podpis_rezervacna_zmluva.c39f939c.svg";